import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import LoadingOverlay from "react-loading-overlay";

import SearchLimit from "@components/molekul/SearchLimit";
import { PaylaterSettingsListLogic } from "./PaylaterSettingsList.logic";
import Button from "@components/atom/Button";

LoadingOverlay.propTypes = undefined;

const PaylaterSettingsList = () => {
  const {
    data,
    columns,
    page,
    sizePerPage,
    totalSize,
    limit,
    loading,
    onTableChange,
    onPageChange,
    onLimitChange,
    onNavigate,
  } = PaylaterSettingsListLogic();

  return (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
          alwaysShowAllBtns: true,
          prePageText: "Sebelumnya",
          nextPageText: "Selanjutnya",
          withFirstAndLast: false,
        })}>
        {({ paginationProps, paginationTableProps }) => (
          <>
            <div className='flex items-end justify-between pb-3 pt-3 md:pt-0'>
              <div className='md:w-1/2'>
                <p className='font-bold text-xl pb-10'>Pengaturan Paylater</p>
                <SearchLimit limit={limit} onLimitChange={onLimitChange} />
              </div>
              <div className='md:w-1/2'>
                <div className='w-full flex items-end justify-end'>
                  <div className='w-1/2 pb-3'></div>
                </div>
                <div className='w-full flex items-end justify-end'>
                  <div className='md:mb-0'>
                    <Button
                      textButton={"Tambah Whitelist"}
                      onClick={onNavigate}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='table-striped table-responsive'>
              <BootstrapTable
                keyField='id'
                remote
                data={data}
                bordered={false}
                loading={loading}
                columns={columns}
                hover
                onTableChange={onTableChange}
                noDataIndication={() => (
                  <div className='text-center'>Empty Data</div>
                )}
                overlay={overlayFactory({
                  spinner: true,
                  background: "rgba(192,192,192,0.3)",
                })}
                {...paginationTableProps}
              />
            </div>
            <div className='flex items-center justify-between'>
              <div>
                <p className='text-muted'>
                  Menunjukan{" "}
                  <span className='font-weight-bold text-dark'>
                    {`${data.length}`}
                  </span>{" "}
                  entry
                </p>
              </div>
              <div>
                {data.length > 0 && (
                  <PaginationListStandalone
                    {...paginationProps}
                    onPageChange={onPageChange}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </PaginationProvider>
    </div>
  );
};

export default PaylaterSettingsList;
